module.exports = __webpack_public_path__ + "static/avatar-c213c5d4835eac774a6bdaf429f5d9b4.png";